import React, { useEffect, useState } from 'react'

// Anti-scraping for contact data: values are stored reversed + base64 so they never
// appear as plain text in the HTML or the JS bundle, and they are only decoded after a
// real user interaction (mouse, touch, keyboard, wheel). Bots that just fetch or render
// the page never get the numbers.
// To add/change a value: btoa('+54 9 11 ...'.split('').reverse().join(''))
export const CONTACTS = {
    international: 'NTUwNS00MDMgKTY4NyggMSs=',
    technical1: 'NjEyOCA1NTQ1IDExIDkgNDUr',
    technical2: 'NDIzMiAyNDc1IDExIDkgNDUr',
    email: 'dGVuLnJ1b2Z1ZGxhdG5lbXVydHNuaUBvZm5p',
}

const decode = (encoded) => atob(encoded).split('').reverse().join('')

const HUMAN_EVENTS = ['pointermove', 'pointerdown', 'touchstart', 'keydown', 'wheel']
const subscribers = new Set()
let isHuman = false

const markHuman = () => {
    if (isHuman) return
    isHuman = true
    HUMAN_EVENTS.forEach((e) => window.removeEventListener(e, markHuman))
    subscribers.forEach((notify) => notify(true))
}

HUMAN_EVENTS.forEach((e) => window.addEventListener(e, markHuman, { passive: true }))

const useHumanInteraction = () => {
    const [human, setHuman] = useState(isHuman)
    useEffect(() => {
        if (isHuman) return setHuman(true)
        subscribers.add(setHuman)
        return () => subscribers.delete(setHuman)
    }, [])
    return human
}

const buildHref = (type, value) => {
    if (type === 'mailto') return `mailto:${value}`
    if (type === 'whatsapp') return `https://api.whatsapp.com/send?phone=${value.replace(/\D/g, '')}`
    return `tel:${value.replace(/[^\d+]/g, '')}`
}

// Text link: shows `placeholder` until a human interacts, then the real value.
// With `children` (e.g. the WhatsApp icon) it always renders them, and builds the
// destination on click if the visitor hasn't interacted yet.
export const ProtectedLink = ({ value, type = 'tel', placeholder = 'Show number', children, ...rest }) => {
    const human = useHumanInteraction()

    if (human) {
        const decoded = decode(value)
        return <a href={buildHref(type, decoded)} {...rest}>{children ?? decoded}</a>
    }

    const openOnClick = (e) => {
        e.preventDefault()
        markHuman()
        if (children) window.open(buildHref(type, decode(value)), '_blank', 'noopener,noreferrer')
    }

    return <a href="#contact" onClick={openOnClick} {...rest}>{children ?? placeholder}</a>
}
